import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/users.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const users = inject(UserService);
  const router = inject(Router);

  return auth.checkAuth().pipe(
    switchMap(res => {
      if (!res.data?.auth) throw new Error('not auth');
      return auth.fetchCurrentUser();
    }),
    switchMap(() => {
      const id = auth.currentUser()?.id;
      if (!id) throw new Error('no user id');
      return users.getRegistration(id).pipe(
        tap(reg => users.currentRegistration.set(reg)),
        map(() => true)
      );
    }),
    catchError(() => {
      router.navigate(['/user/login']);
      return of(false);
    })
  );
};
